import { useTikTokAdvertiserSummaryData } from '@anytag/shared-organisms';
import { TikTokAdCampaignReport, TikTokAdsReportRoot } from '../../../pages/tiktok-advertiser-pages';

export const AdCampaignReportRoot = () => {
  const { summaryData, loading } = useTikTokAdvertiserSummaryData();

  return <TikTokAdsReportRoot summaryData={summaryData} loading={loading} />;
};

export const AdCampaignReport = () => {
  const { summaryData, loading } = useTikTokAdvertiserSummaryData();

  return <TikTokAdCampaignReport summaryData={summaryData} loading={loading} />;
};
